<template>
  <v-container>
    <lottie :height="animationSize" :options="animationOptions"
            :style="'height: '+ animationSize + 'px; width: ' + animationSize + ';'"
            :class="{'my-overlay': showAnimation}"
            @animCreated="handleAnimation"/>
    <v-row class="text-center">
      <v-col class="ma-0 pa-0" cols="12">
        <v-img
            :src="require('../assets/ls-h-branco.svg')"
            contain
            height="60"
        />
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col class="ma-2 pa-2" cols="12">
        <v-spacer></v-spacer>
        <p class="text-caption">Total em Prêmios</p>
        <h1 class="display-3">
          <span class="text-subtitle-1">R$ </span>
          <number
              ref="numTotalPrize"
              :from="this.numberEffect.from"
              :to="this.numberEffect.to"
              :format="theFormat"
              :duration="this.numberEffect.duration"
              :delay="1"
              easing="Expo.easeOut"
              @complete="onNumberEffectComplete"
          />
          <span class="text-subtitle-1">,00</span>
        </h1>
        <v-spacer></v-spacer>
      </v-col>
    </v-row>
    <div v-if="!this.$store.state.list">
      <v-card
          class="mx-auto"
          max-width="344"
      >
        <v-card-text>
          <v-alert>Nenhuma lista de participantes foi carregada</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              @click="$router.push({name: 'LoadList'})"
          >
            Carregar Participantes
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </div>
    <div v-else id="dice">
      <div class="example-3d">
        <swiper ref="mySwiper" :options="swiperOption" class="swiper">
          <swiper-slide v-for="person in virtualData" :key="person.number" :person-id="person.number">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="mb-1" style="font-size: 2rem!important;">{{ person.name }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ person.hiddenEmail }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </swiper-slide>
        </swiper>
      </div>
      <v-row class="text-center">
        <v-col class="ma-2 pa-2" cols="12">
          <v-btn :loading="loading" :disabled="this.loading" color="success" x-large @click="loadData()">
            Sortear
          </v-btn>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
      <special-winners></special-winners>
    </div>
  </v-container>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import Lottie from 'vue-lottie'
import * as animationData from '../assets/animations/7893-confetti-cannons.json'
import {Random} from "random-js";
import {mapActions} from "vuex";
import SpecialWinners from "../components/SpecialWinners"

const random = new Random(); // uses the nativeMath engine

export default {
  components: {
    SpecialWinners,
    Swiper,
    SwiperSlide,
    Lottie
  },
  data: () => ({
    prices: {
      "CPA-10": 440,
      "CPA-20": 590,
      "CEA": 740,
      "CFP": 3190,
      "ANCORD": 790,
      "HP-12C": 390
    },
    numberEffect: {
      from: 0,
      to: 0,
      duration: 0.2
    },
    totalPrize: 0,
    dialog: false,
    animationSize: 20,
    anim: null,
    animationOptions: {
      animationData: animationData.default,
      loop: true,
      autoplay: false,
      rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
    },
    removeFromNextRound: null,
    showAnimation: false,
    sliceSize: 60,
    pickedUp: 0,
    loading: false,
    people: [],
    audioPeao: new Audio(require('../assets/peao-do-bau.mp3')),
    audioCash: new Audio(require('../assets/cash-register.mp3')),
    virtualData: [],
    swiperOption: {
      loop: true,
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
    }
  }),
  created () {
    this.people = this.$store.state.list
  },
  mounted () {
    this.virtualData = []
    this.totalPrize = this.$store.state.totalPrize
    this.numberEffect.to = this.$store.state.totalPrize
    this.loadVirtualData()
    this.$nextTick()
        .then(function () {
          // console.log('tick')
        })
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.$swiper
    },
    winner (idx) {
      return this.virtualData[idx]
    }
  },
  methods: {
    onNumberEffectComplete () {
      // this.audioCash.play()
    },
    theFormat (number) {
      number = Math.round(number)
      // console.log(number.toLocaleString('pt-BR', { minimumFractionDigits: 0 }))
      return number.toLocaleString('pt-BR', { minimumFractionDigits: 0 })
    },
    loadData () {
      // this.pickedUp = Math.floor(Math.random() * this.people.length);
      // this.loadVirtualData()
      this.loading = true
      this.loadVirtualData()
      var _this = this
      this.$nextTick()
          .then(function () {
            // console.log('tick')
            _this.loading = true
          })
      this.$nextTick()
          .then(function () {
            // console.log('tick')
            _this.loading = true
          })
      this.lottery()
    },
    lottery () {
      this.loading = true
      const lastWinnerIndex = this.pickedUp
      let tempPicked = lastWinnerIndex

      //Remove last winner from Virtual data
      if (this.removeFromNextRound) {
        this.removeFromVirtualList(this.removeFromNextRound)
        this.removeFromNextRound = null
      }

      while (Math.abs(tempPicked - lastWinnerIndex) <= (this.virtualData.length / 3)) {
        tempPicked = Math.floor(random.integer(1, this.virtualData.length))
      }
      // console.log('index = ', tempPicked)
      //TODO: Validate if is allowed to repeat the winner
      this.pickedUp = tempPicked

      this.playSound('')
      this.swiper.slideTo(
          tempPicked + (2 * this.virtualData.length),
          3500, false
      )
    },
    removeFromVirtualList (idx) {
      this.virtualData.splice(idx, 1);
    },
    setWinner () {
      this.getWinnerFromList()
      this.showConsoleInfo()
      let lucky = this.pickedUp
      let winner = this.virtualData[lucky]
      this.addWinner(winner)
      this.removeItemFromList(winner)
      this.removeFromNextRound = lucky
      this.addPrizeAmount(this.prices[winner.course])

      this.numberEffect.from = this.totalPrize
      this.totalPrize += this.prices[winner.course]
      this.numberEffect.to = this.totalPrize

      this.numberEffect.duration = Math.round(this.prices[winner.course] / 1000)
      console.log(this.$refs.numTotalPrize)
      this.$refs.numTotalPrize.play()
      this.showConfettiAnimation()

      console.log('Playing ... ', this.$store.state.totalPrize.toLocaleString('pt-br', { minimumFractionDigits: 0 }));
      // this.removeFromVirtualList(lucky)
    },
    showConsoleInfo (processInfo = 'SORTEADO') {
      let lucky = this.pickedUp
      console.debug('activeIndex: ', this.swiper.activeIndex, ' - loopedSlides: ', this.swiper.loopedSlides, ' - realIndex: ', lucky, this.swiper)
      console.info('- - - - - - - ' + processInfo + '- - - - - - - - ');
      console.info('Nome na Roleta: ', this.virtualData[lucky].name);
      console.info('Nome preenchido: ', this.virtualData[lucky].fullName);
      console.info('Email: ', this.virtualData[lucky].email);
      console.info('Telefone: ', this.virtualData[lucky].phone);
      /*
            console.info('Real Index: ', this.swiper.realIndex)
            console.info('Index: ', this.swiper.activeIndex)
            console.info('Real Index: ', this.virtualData[this.swiper.realIndex])
            console.info('Virtual data Index -1: ', this.virtualData[this.swiper.realIndex-2])
            console.info('Index: ', this.virtualData[this.swiper.activeIndex])
            console.info('Slides Index: ', this.swiper.slides[this.swiper.activeIndex])
            console.info('Real Index: ', this.virtualData)
            const idx = this.activeIndex % this.virtualData.length
            console.info('Winner: ', this.virtualData[idx])
      */
      console.info('- - - - - - - - - - - - - - - - - - - - - ');
    },
    playSound (sound) {
      sound = require('../assets/peao-do-bau-short.mp3')
      if (sound) {
        var audio = new Audio(sound);
        audio.onended = () => {
          this.showConfettiAnimation()
          this.setWinner()
          // this.loading = false
        }
        audio.play();
      }
    },
    getWinnerFromList () {
      var elSlide = this.swiper.slides[this.swiper.activeIndex]
      let id = elSlide.getAttribute('person-id')
      var idxWinnwer = this.virtualData.findIndex(p => p.number == id);
      this.pickedUp = idxWinnwer
      console.log('Winner: ', this.virtualData[idxWinnwer])
    },
    loadVirtualData (length = this.sliceSize) {
      this.loading = true
      let _self = this
      _self.$nextTick()
          .then(function () {
            _self.loading = true
            // console.log('loading virtual ...')
          })
      let tempSlides = []
      // console.log('Loading size: ', length)
      let index = 0
      let p = undefined
      this.virtualData = []
      _self.swiper.slideTo(0, 0, false)
      if (length >= this.$store.state.list.length) {
        _self.virtualData = this.people
      } else {
        let counter = 0
        for (counter = 0; counter < length - 1; counter++) {
          index = random.integer(1, this.people.length)
          p = this.people[index]
          if (p !== undefined) tempSlides.push(p)
        }
        const unique = [...new Set(tempSlides)];
        _self.virtualData = unique
      }

      // this.sleep(1000)
      _self.$nextTick()
          .then(function () {
            _self.loading = false
            // console.log('setting loaging false')
          })
      _self.swiper.slideTo(0, 200, false)
      // this.sliceSize = _self.virtualData.length
      this.loading = false
    },
    handleAnimation: function (anim) {
      console.log('animation created')
      this.anim = anim;
    },
    showConfettiAnimation () {
      this.animationSize = window.innerHeight
      this.showAnimation = true
      const _this = this
      console.log('showing the animation...')
      if (_this.anim) {
        _this.anim.setSpeed(2.3)
        _this.anim.play()
      }
      setTimeout(function () {
        //console.log('a few seconds after...')
        _this.showAnimation = false
        _this.animationSize = 1
        if (_this.anim) _this.anim.stop()
        _this.loading = false
      }, 1700)
    },
    ...mapActions(['addWinner', 'addConfirming', 'clearConfirming', 'removeItemFromList', 'addPrizeAmount'])
  },
}
</script>

<style lang="scss" scoped>
.example-3d {
  max-width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
}

.swiper {
  height: 50%;
  width: 50%;

  .swiper-slide-3d {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 400px;
    height: 180px;
    text-align: center;
    font-weight: bold;
    font-size: 22px;
    background-color: #2C8DFB;
    background-position: center;
    background-size: cover;
    color: white;
  }

  .swiper-slide {
    text-align: center;
    font-size: 72px;
    background: #1E1E1E;
    color: white;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }
}

.my-overlay {
  align-items: center;
  display: flex;
  justify-content: center;
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
}
</style>
